/**
 * External dependencies
 */
import { Reducer } from 'redux';

/**
 * Internal dependencies
 */
import { setAuthToken } from '@/store/actions';
import initialState from '../../initialState';
import isAction from '../../isAction';

const token: Reducer<string | null> = (
	state = initialState.auth.token,
	action
) => (isAction(action, setAuthToken) ? action.payload : state);

export default token;
